import React, { useEffect, useState, useRef } from "react";

const LiveChat = ({ data, handleChat }) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const chatBodyRef = useRef(null); // ref to scrollable div

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (input.trim()) {
      // setMessages([...messages, { message: input, sender: 'You' }]);
      setInput("");
      handleChat(input);
    }
  };
  useEffect(() => {
    
    if (data.length > 0) {
      setMessages((prev) => [...prev, ...data]);
      const el = chatBodyRef.current;
      console.log(el.scrollHeight);
      el.scrollTop = el.scrollHeight;
    }
  }, [data]);

  return (
    <>
      <div className="chat-window" ref={chatBodyRef} id="chatBodyRef">
        <div className="messages">
          {messages.map((msg, index) => (
            <div key={index} className={`message ${msg.sender} text-white`}>
              <span>{msg.sender}: </span>
              <span>{msg.message}</span>
            </div>
          ))}
        </div>
        <form onSubmit={handleSendMessage} className="message-input">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Type a message..."
            className="bg-secondary-gray text-white"
          />
          <button type="submit" className="yellow-title">Send</button>
        </form>
      </div>
    </>
  );
};

export default LiveChat;
